import { LandingPlayground } from './LandingPlayground';
import { TrainingSoftSkillsAdmin } from './TrainingSoftSkillsAdmin';

export const Admin = {
  LandingPlayground,
  TrainingSoftSkillsAdmin,
};
